import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { GridContainer } from './grid.styled';
export const gridContainerGroupStyles = ({ theme, $variant, $groupStriped, }) => css `
	${$groupStriped &&
    css `
		position: relative;
		padding-top: ${pxToRem(Number(theme.spacing['600']) / 2)};
		padding-bottom: ${pxToRem(Number(theme.spacing['600']) / 2)};
		margin-bottom: ${pxToRem(Number(theme.spacing['600']) / 2)};
		background-color: ${theme.colors.extralight.bgSite};

		&::before {
			z-index: -1;
			content: '';
			position: absolute;
			left: -0.4rem;
			right: -0.4rem;
			bottom: 0px;
			top: 0;
			background-color: ${theme.colors.extralight.bgSite};
		}
	`}

	${GridContainer} {
		${$variant === 'default' &&
    css `
			+ ${GridContainer} {
				:not(:last-of-type) {
					margin-bottom: ${pxToRem(theme.spacing['600'])};
				}

				:nth-of-type(2) {
					margin-top: ${pxToRem(theme.spacing['600'])};
				}
			}
		`}

		${$variant === 'striped' &&
    css `
			+ ${GridContainer} {
				position: relative;
				padding-top: ${pxToRem(Number(theme.spacing['600']) / 2)};
				padding-bottom: ${pxToRem(Number(theme.spacing['600']) / 2)};

				:nth-of-type(2) {
					margin-top: ${pxToRem(Number(theme.spacing['600']) / 2)};
				}

				:nth-of-type(2n) {
					background-color: ${theme.colors.extralight.bgSite};

					&::before {
						z-index: -1;
						content: '';
						position: absolute;
						left: -0.4rem;
						right: -0.4rem;
						bottom: 0px;
						top: 0;
						background-color: ${theme.colors.extralight.bgSite};
					}
				}
			}
		`}

		// @NOTE: Reset styling for nested GridContainers
		${GridContainer} {
			margin-top: 0;
			padding-top: 0;

			&::before {
				content: unset;
			}
		}
	}
`;
export const GridContainerGroup = styled.div `
	${gridContainerGroupStyles}
`;
//# sourceMappingURL=gridGroup.styled.js.map